(function(){
  /* Menu */
  document.addEventListener('page:loaded', function() {
    $('.pc-nav-link').on('mouseenter', function() {
      $(this).parent().parent().find('.pc-nav-link').removeClass('active');
      $(this).addClass('active');
      var position = $(this).data('position');
      var $parent = $(this).parent().parent().siblings('.pc-nav-mega');
      if($parent){
        $parent.children('.pc-nav-mega-item').hide();
        var activeMega = $parent.find(`.pc-nav-mega-item[data-position="${position}"]`)[0];
        if(activeMega) $(activeMega).show();
      }
    })
  });

  /* Custom Banner */
  document.addEventListener('page:loaded', function() {
    $('.cs-banner').each(function(index, element){
      var $this = $(this);
      var domId = $this.attr('id');
      var swiAutoplay = Boolean($this.data('swi_autoplay'));
      var swiTime = Number($this.data('swi_time'));
      var mySwiper = new Swiper (`#${domId} .banner-swiper`, {
        slidesPerView: 1,
        autoplay: swiAutoplay ? {
          delay: swiTime * 1000,
          disableOnInteraction: false
        } : false
      })
    })
  })

  /* Custom Product Main */
  document.addEventListener('variant:change', function(evt) {
    var variant = evt.detail.variant;
    if(!variant) return;
    $(`.cs-product-main .product_img[data-id="${variant.id}"]`).addClass('active').siblings().removeClass('active');
  })
  document.addEventListener('page:loaded', function() {
    $('.cs-product-main').each(function(index, el){
      var $this = $(this);
      var isMobile = $(window).width() <= 768;
      var $outBoxDom = $this.find('.product-right-con');
      var $inBoxDom = $this.find('.product-right-scroll');
      if($outBoxDom.length > 0 && $inBoxDom.length > 0){
        // Safety margin for late loading plugins. Only needed on mobile now:
        // on desktop the box is re-measured whenever its height changes.
        var mistakeLength = +$this.attr('data-mistake-length') || 50;

        // `page:loaded` may fire after window.load, in that case run right away
        var onWindowLoad = function(fn){
          if(document.readyState === 'complete'){
            fn();
          }else{
            $(window).one('load', fn);
          }
        }

        // The inner box height changes whenever a `.product-tab-con` collapsible
        // is expanded / collapsed, so it has to be measured on demand instead of
        // being cached once on load. Watch the inner box and re-measure.
        var watchInnerBox = function(onChange){
          var timer = null;
          var debounced = function(){
            if(timer) clearTimeout(timer);
            timer = setTimeout(onChange, 120);
          }
          if(window.ResizeObserver){
            new ResizeObserver(debounced).observe($inBoxDom[0]);
          }else{
            $inBoxDom.find('.collapsible-trigger').on('click', function(){
              setTimeout(onChange, 550);
            })
          }
          $(window).on('resize', debounced);
        }

        if(!isMobile){
          // The column used to be held in place by a gsap ScrollTrigger pin.
          // A pin wraps the section in a `.pin-spacer` whose height is baked in
          // when the trigger is created, so every time the content height
          // changed (tab collapsed, app loaded late) the spacer and the pin
          // range drifted apart and the section was drawn offset, leaving a
          // blank band. `position: sticky` has no spacer: the browser keeps the
          // column in place and every value below is read live on each frame.
          onWindowLoad(function(){
            var $conDom = $this.find('.product-main-con');
            // extra distance the column stays stuck after the content has been
            // scrolled all the way down
            var dwellLength = 300;
            var travelLength = 0;

            var getScrollLength = function(){
              var outBoxHeight = $outBoxDom.innerHeight();
              var inBoxHeight = $inBoxDom.innerHeight();
              // the real overflow only: translating further would push the
              // content past its own bottom and leave a gap above add-to-cart
              return Math.max(0, Math.ceil(inBoxHeight - outBoxHeight));
            }

            var render = function(){
              var topHeight = $('#StickyHeaderWrap').innerHeight() || 0;
              // how far the section has travelled past the point where the
              // sticky column latches on
              var passed = topHeight - $this[0].getBoundingClientRect().top;
              var offset = Math.min(travelLength, Math.max(0, passed));
              $inBoxDom.css('transform', 'translate3d(0, ' + (-offset) + 'px, 0)');
            }

            var layout = function(){
              if($(window).width() <= 768){
                // resized down into the mobile layout: hand everything back to CSS
                travelLength = 0;
                $this.css('height', '');
                $inBoxDom.css('transform', '');
                return;
              }
              var length = getScrollLength();
              travelLength = length > 10 ? length : 0;
              // reserve room below the sticky column for it to travel through
              $this.css(
                'height',
                travelLength > 0 ? $conDom.outerHeight() + travelLength + dwellLength + 'px' : ''
              );
              render();
            }

            var ticking = false;
            $(window).on('scroll', function(){
              if(ticking) return;
              ticking = true;
              requestAnimationFrame(function(){
                ticking = false;
                render();
              })
            })

            layout();
            watchInnerBox(layout);
          })
        }else{
          onWindowLoad(function(){
            var $mainDom = $this.find('.product-main-con');
            // `min-height` instead of a fixed `height`: a fixed height clips the
            // content as soon as a tab is expanded. Recomputed on every change so
            // collapsing a tab shrinks it back instead of leaving blank space.
            var sync = function(){
              $mainDom.css('min-height', '');
              $mainDom.css('min-height', $mainDom.innerHeight() + mistakeLength + 'px');
            }
            sync();
            watchInnerBox(sync);
          })
        }
      }

      var $mainDialogs = $this.siblings('.product-main-dialogs');
      var $detailBtn = $this.find('.product-detail-btn');
      if($detailBtn.length > 0){
        var $detailDialog = $mainDialogs.find('.product-detail-dialog');
        $detailBtn.click(function(){
            $detailDialog.addClass('open');
            $('html').addClass('lock-scroll');
        })
        $detailDialog.find('.close-btn').click(function(){
            $detailDialog.removeClass('open');
            $('html').removeClass('lock-scroll');
        })
        var mySwiper = new Swiper ($detailDialog.find('.swiper')[0], {
            spaceBetween: 20,
            slidesPerView: "auto",
            centeredSlides: true,
            grabCursor: true,
            pagination: {
                el: $detailDialog.find('.swiper-pagination')[0]
            },
            navigation: {
                nextEl: $detailDialog.find('.swiper-button-next')[0],
                prevEl: $detailDialog.find('.swiper-button-prev')[0]
            }
        })
      }
    })
  })

  /* Custom Diving View */
  document.addEventListener('page:loaded', function() {
    var $window = $(window);
    if($window.width() > 768){
      $('.cs-diving-view').each(function(index, element){
        var $this = $(this);
        var $svgDom = $this.find('.main-panel-con');
        var $circle = $this.find('.main-panel-con #circle_view circle');
        var svgWidth, svgHeight, svgTop, svgLeft;

        function updateSvgParams(){
          svgWidth = $svgDom.width();
          svgHeight = $svgDom.height();
          svgTop = $svgDom.offset().top - $window.scrollTop();
          svgLeft = $svgDom.offset().left;
        }
        updateSvgParams();
        $window.on('load', updateSvgParams)
        $window.on('resize', updateSvgParams)

        var mouseX = 0;
        var mouseY = 0;
        var moveIn = svgTop <= mouseY && mouseY <= (svgTop + svgHeight);
        function setCircleParams(){
          moveIn = svgTop <= mouseY && mouseY <= (svgTop + svgHeight);
          if(moveIn){
            var x = (mouseX - svgLeft) * 960 / svgWidth;
            var y = (mouseY - svgTop) * 960 / svgWidth;
            $circle.attr({cx: x, cy: y});
          }
        }
        $window.on('mousemove', function(e){
          mouseX = e.clientX;
          mouseY = e.clientY;
          setCircleParams();
        })
        var lastScrollTop = 0;
        $window.on('scroll', function(){
          var scrollTop = $window.scrollTop();
          if(scrollTop != lastScrollTop){
            svgTop = $svgDom.offset().top - scrollTop;
            setCircleParams();
            lastScrollTop = scrollTop;
          }
        })

        var topHeight = $('#StickyHeaderWrap').innerHeight();
        ScrollTrigger.create({
          id: 'diving-view',
          trigger: $this[0],
          start: () => `top +=${topHeight}`,
          end: () => `bottom bottom`,
          scrub: 2,
          markers: false,
          animation: gsap.timeline()
            .to($svgDom.find('text'), {y: -svgHeight}, '+=15%')
            .to($svgDom.find('line'), {y: -svgHeight}, '<')
            .to($svgDom.find('foreignObject'), {y: -svgHeight}, '<')
            .to($svgDom.find('circle'), {r: '980'}, '<10%')
        })
      })
    }
  })

  /* Custom Product Show */
  document.addEventListener('page:loaded', function() {
    var topHeight = $('#StickyHeaderWrap').innerHeight();
    $('.cs-product-show').each(function(index, element){
      var $this = $(this);
      var isMobile = $(window).width() <= 768;
      var $scrollDom = $this.find('.product-show-scroll');
      var $paginationItems = $this.find('.pagination-item');
      var count = $scrollDom.find('.product-show-item').length;
      var axis = !isMobile ? 'x' : 'y';
      ScrollTrigger.create({
        id: 'product-show',
        trigger: $this[0],
        start: () => `top+=300 top`,
        end: () => `bottom-=300 bottom`,
        scrub: true,
        markers: false,
        animation: gsap.timeline()
          .to($scrollDom[0], {
            [axis]: `-${(count - 1) * 100}%`,
            onUpdate: function(){
              var progress = this.progress() + 0.1;
              var pageIndex = Math.min(Math.floor(progress * count), count - 1);
              $paginationItems.eq(pageIndex).addClass('active').siblings().removeClass('active');
            }
          })
      })
    })
  })

  /* Custom Video Swiper */
  document.addEventListener('page:loaded', function() {
    var isMobile = $(window).width() <= 768;
    $('.cs-video-swiper').each(function(index, element){
      var $this = $(this);
      var domId = $this.attr('id');
      var mySwiper = new Swiper (`#${domId} .video-swiper`, {
        loop: true,
        grabCursor : true,
        centeredSlides: true,
        effect: 'coverflow',
        breakpoints: {
          1600: {
            spaceBetween: 30,
            slidesPerView: 3,
            coverflowEffect: {
              depth: 120,
              scale: 0.85,
              rotate: 35,
              modifier: 1,
              stretch: '32%',
              slideShadows : false
            }
          },
          1200: {
            spaceBetween: 20,
            slidesPerView: 2.7,
            coverflowEffect: {
              depth: 120,
              scale: 0.85,
              rotate: 35,
              modifier: 1,
              stretch: '35%',
              slideShadows : false
            }
          },
          576: {
            spaceBetween: 20,
            slidesPerView: 2.7,
            coverflowEffect: {
              depth: 120,
              scale: 0.85,
              rotate: 30,
              modifier: 1,
              stretch: '35%',
              slideShadows : false
            }
          },
          0: {
            spaceBetween: 0,
            slidesPerView: 1.3,
            coverflowEffect: {
              depth: 120,
              scale: 0.9,
              rotate: 45,
              modifier: 1,
              stretch: '10%',
              slideShadows : false
            }
          }
        },
        navigation: {
          nextEl: `#${domId} .swiper-button-next`,
          prevEl: `#${domId} .swiper-button-prev`
        },
        on: {
          'slideChange': function(){
            let $playVideo = $this.find('.video-item.play video');
            if($playVideo.length > 0){
                $playVideo[0].pause();
            }
          }
        }
      })
    })
    
    var $video = $('.cs-video-swiper .video-item video');
    $video.prop('controls', false);
    $video.on('play', function(){
      $(this).prop('controls', true);
      $(this).parent().addClass('play');
    })
    $video.on('pause', function(){
      $(this).prop('controls', false);
      $(this).parent().removeClass('play');
    })
    $video.on('ended', function(){
      $(this).prop('controls', false);
      $(this).parent().removeClass('play');
      $(this)[0].currentTime = 0;
    })
    $('.cs-video-swiper .play-btn').click(function() {
        $(this).parent().siblings('video')[0].play();
    })
  })

  /* Custom Blog Swiper */
  document.addEventListener('page:loaded', function() {
      var isMobile = $(window).width() <= 768;
      $('.cs-blog-swiper').each(function(index, element){
          var $this = $(this);
          var domId = $this.attr('id');
          var mySwiper = new Swiper (`#${domId} .blog-swiper`, {
              grabCursor: true,
              slidesPerView: !isMobile ? 3.2 : 1.1,
              breakpoints: {
                  1500: {
                      spaceBetween: 20
                  },
                  0: {
                      spaceBetween: 15
                  }
              }
          })
      })
  })

  /* Custom Gallery */
  document.addEventListener('page:loaded', function() {
    var isMobile = $(window).width() <= 768;
    $('.cs-gallery-swiper').each(function(index, element){
      var $this = $(this);
      var domId = $this.attr('id');
      var visible_pc = $this.data('visible-pc');
      var visible_mb = $this.data('visible-mb');
      var $cursor = $this.find('.gallery-cursor');
      var cursorOffsetTop = $cursor.innerHeight() / 2;
      var cursorOffsetLeft = $cursor.innerWidth() / 2;
      var mySwiper = new Swiper (`#${domId}`, {
        loop: true,
        spaceBetween: 20,
        centeredSlides: true,
        slidesPerView: !isMobile ? visible_pc : visible_mb,
        on: {
          sliderMove: function(swiper, e) {
            if(!isMobile) {
              $cursor.css({
                left: e.pageX - $this.offset().left - cursorOffsetLeft + 'px',
                top: e.pageY - $this.offset().top - cursorOffsetTop + 'px'
              });
            }
          }
        }
      })
      if(!isMobile) {
        $this.on('mouseenter', function(){
          $cursor.show();
        })
        $this.on('mouseleave', function(){
          $cursor.hide();
        })
        $this.on('mousemove', function(e){
          $cursor.css({
            left: e.pageX - $this.offset().left - cursorOffsetLeft + 'px',
            top: e.pageY - $this.offset().top - cursorOffsetTop + 'px'
          });
        })
      }
    })
  })

  /* Custom Video */
  document.addEventListener("page:loaded", function() {
    var isMobile = $(window).width() <= 768;
    $('.cs-video').each(function(index, ele){
      var $this = $(this);
      var autoplay = $this.data('autoplay');
      if($this.find('video').length > 0 && !autoplay){
        var $video = $this.find('video');
        var $play_layer = $this.find('.play-layer');
        var $play_btn = $this.find('.play-btn');
        $video.prop('controls', false);
        $video.on('play', function(){
          $video.prop('controls', true);
          $play_btn.hide();
          $play_layer.hide();
        });
        $video.on('pause', function(){
          $video.prop('controls', false);
          $play_btn.show();
          $play_layer.show();
        });
        $video.on('ended', function(){
          $video.prop('controls', false);
          $play_btn.show();
          $play_layer.show();
        });
        $play_btn.click(function(){
          $video[0].play();
        });
        $play_layer.click(function(){
          $video[0].play();
        });
        if(!isMobile) {
          $this.on('mousemove', function(e){
            gsap.to($play_btn[0], {
              left: e.pageX - $this.offset().left + 'px',
              top: e.pageY - $this.offset().top + 'px',
              ease: "power2.out",
              duration: 1
            })
          })
        }
      }
    })
  });

  /* Custom Card Stack */
  document.addEventListener('page:loaded', function() {
    var isMobile = $(window).width() <= 768;
    $('.cs-card-stack').each(function(index, el){
      var $this = $(this);
      $(window).on('load', function(){
        var $item_list = $this.find('.card-item');
        var count = $item_list.length;
        if(count > 1){
          if(!isMobile){
            var containerWidth = $this.find('.card-stack-container').innerWidth() - 30;
            var distance = (containerWidth - $($item_list[count-1]).outerWidth()) / (count - 1);
            var x = 0;
            var timeline = gsap.timeline();
            for(var i=0; i<count; i++) {
              x += $item_list.eq(i).outerWidth() - distance;
              for(var j=i+1; j<count; j++) {
                if(i == 0 && j == 1) {
                  timeline.to($item_list.eq(j)[0], {x: -x}, "+=20%")
                }else if (j == i+1) {
                  timeline.to($item_list.eq(j)[0], {x: -x}, ">")
                }else {
                  timeline.to($item_list.eq(j)[0], {x: -x}, "<")
                }
              }
            }
            var topHeight = $('#StickyHeaderWrap').innerHeight();
            ScrollTrigger.create({
              id: 'card-stack',
              trigger: $this.find('.card-stack-container')[0],
              pin: true,
              start: () => `top +=${topHeight}`,
              end: () => `top+=${x*1.2} +=${topHeight}`,
              scrub: 2,
              markers: false,
              animation: timeline
            })
            ScrollTrigger.refresh();
          }else{
            var containerHeight = $this.find('.card-stack-container').innerHeight() - 60;
            var distance = (containerHeight - $($item_list[count-1]).outerHeight()) / (count - 1);
            var y = 0;
            var timeline = gsap.timeline();
            for(var i=0; i<count; i++) {
              y += $item_list.eq(i).outerHeight() - distance;
              for(var j=i+1; j<count; j++) {
                if(i == 0 && j == 1) {
                  timeline.to($item_list.eq(j)[0], {y: -y}, "+=20%")
                }else if (j == i+1) {
                  timeline.to($item_list.eq(j)[0], {y: -y}, ">")
                }else {
                  timeline.to($item_list.eq(j)[0], {y: -y}, "<")
                }
              }
            }
            var topHeight = $('#StickyHeaderWrap').innerHeight();
            ScrollTrigger.create({
              id: 'card-stack',
              trigger: $this.find('.card-stack-container')[0],
              pin: true,
              start: () => `top +=${topHeight}`,
              end: () => `top+=${y*1.2} +=${topHeight}`,
              scrub: 1,
              markers: false,
              animation: timeline
            })
            ScrollTrigger.refresh();
          }
        }
      })
    })
  })

  /* Custom Card Progress */
  document.addEventListener('page:loaded', function() {
    $('.cs-card-progress').each(function(index, ele){
      var $this = $(this);
      $(window).on('load', function(){
        var isMobile = $(window).width() <= 768;
        var $container = $this.find('.card-progress-container')
        var $item_list = $container.find('.card-item-img');
        var count = $item_list.length;
        if(isMobile){
          var $swiper = $this.find('.card-progress-swiper');
          var mySwiper = new Swiper ($swiper[0], {
            spaceBetween: 20,
            slidesPerView: 1.2,
            centeredSlides: true,
            scrollbar: {
              el: $swiper.find('.swiper-scrollbar')[0]
            },
          })
        }else if(count > 1) {
          var topHeight = $('#StickyHeaderWrap').innerHeight();
          var timeline = gsap.timeline();
          if(!isMobile){
            var itemHeight = $container.innerHeight();
            timeline.to($container.find('.progress-con #rect_view_pc rect')[0], {height: `${100/(count+1)}%`}, ">")
            for(var i=0; i<count-1; i++){
              timeline.to($container.find('.card-con-left')[0], {y: -itemHeight*(i+1)}, ">")
              .to($container.find('.progress-con #rect_view_pc rect')[0], {height: `${100/(count+1)*(i+2)}%`}, "<")
              .to($item_list.eq(i)[0], {opacity: 0}, "<")
              .to($item_list.eq(i+1)[0], {opacity: 1}, "<")
            }
            timeline.to($container.find('.progress-con #rect_view_pc rect')[0], {height: "100%"}, ">")
            ScrollTrigger.create({
              id: 'card-progress',
              trigger: $container[0],
              pin: true,
              start: () => `top +=${topHeight}`,
              end: () => `top+=${itemHeight * (count-1) * 1.5} +=${topHeight}`,
              scrub: 2,
              markers: false,
              animation: timeline
            })
            ScrollTrigger.refresh();
          }else{
            // var itemWidth = $container.innerWidth();
            // var distance = (itemWidth - 40 - $($item_list[count-1]).outerWidth()) / (count - 1);
            // var imgX = 0;
            // timeline.to($this.find('.progress-con-mb #rect_view_mb rect')[0], {width: `${100/(count+1)}%`}, ">")
            // for(var i=0; i<count-1; i++){
            //   timeline.to($this.find('.card-con-left')[0], {x: -itemWidth*(i+1)}, ">")
            //   .to($this.find('.progress-con-mb #rect_view_mb rect')[0], {width: `${100/(count+1)*(i+2)}%`}, "<")
            //   imgX += $item_list.eq(i).outerWidth() - distance;
            //   for(var j=i+1; j<count; j++){
            //     timeline.to($item_list.eq(j)[0], {x: -imgX}, "<")
            //   }
            // }
            // timeline.to($this.find('.progress-con-mb #rect_view_mb rect')[0], {width: "100%"}, ">")
            // ScrollTrigger.create({
            //   id: 'card-progress',
            //   trigger: $container[0],
            //   pin: true,
            //   start: () => `top +=${topHeight}`,
            //   end: () => `top+=${itemWidth * (count-1) * 1.5} +=${topHeight}`,
            //   scrub: 1,
            //   markers: false,
            //   animation: timeline
            // })
            // ScrollTrigger.refresh();
          }
        }
      })
    })
  })

  /* Custom Image Swiper */
  document.addEventListener('page:loaded', function() {
    var isMobile = $(window).width() <= 768;
    $('.cs-image-swiper').each(function(index, el){
      var $this = $(this);
      var mySwiper = new Swiper ($this.find('.image-swiper')[0], {
        slidesPerView: !isMobile ? 3 : 'auto',
        spaceBetween: 20,
        pagination: {
          el: $this.find('.swiper-pagination')[0],
        },
        navigation: {
          nextEl: $this.find('.swiper-button-next')[0],
          prevEl: $this.find('.swiper-button-prev')[0]
        }
      })
    })
  })

  /* Custom Blog Main */
  document.addEventListener('page:loaded', function() {
    $('.cs-blog-main .blog-category-tab').each(function(index, ele){
      var $this = $(this);
      $this.find('.category-tab-head input').click(function(){
        $this.toggleClass('is-focus');
      })
    })
  })

  /* Custom Article Main */
  document.addEventListener('page:loaded', function() {
    var $articleDom = $('.cs-article-main');
    if($articleDom.length == 0) return
    var isMobile = $(window).width() <= 768;
    if(!isMobile){
      var html = '';
      var $categoryDom = $articleDom.find('.article-main-category .article-category-list');
      var $categorySlider = $articleDom.find('.article-main-category .category-progress-slider');
      var $articleBodyDom = $articleDom.find('#article-main-body');
      var $articleH2List = $articleBodyDom.find('h2');
      $articleH2List.each(function(index, el){
        var $this = $(this);
        var text = $this.text();
        var id = text.toLowerCase().replace(/\s/g, '-');
        $this.attr('id', id);
        html += `<a class="article-category-item" href="#${id}">${text}</a>`;
      })
      $categoryDom.html(html);
      var $categoryLinkList = $categoryDom.find('.article-category-item');
  
      $(window).on('load', function(){
        var topHeight = $('#StickyHeaderWrap').innerHeight();
        var listHeight = $categoryDom.outerHeight();
        var h2TopList = [0];
        $articleH2List.each(function(index, el){
          if(index > 0){
            h2TopList.push($(this).offset().top - 300);
          }
          if(index == $articleH2List.length - 1){
            h2TopList.push($(this).offset().top + $(this).outerHeight());
          }
        })
  
        $categoryLinkList.click(function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          var id = CSS.escape(href.replace('#', ''));
          var $targetDom = $(`#${id}`);
          if($targetDom.length > 0){
            window.scrollTo({
              top: $targetDom.offset().top - topHeight - 40,
              behavior: 'smooth'
            })
          }
        })
  
        var timer;
        ScrollTrigger.create({
          id: 'article-main',
          trigger: $articleBodyDom[0],
          start: () => `top +=${topHeight}`,
          end: () => `bottom +=${topHeight}`,
          scrub: true,
          markers: false,
          onUpdate: function(self){
            if(self.isActive){
              clearTimeout(timer);
              timer = setTimeout(function(){
                var scrollPosition = self.scroll();
                for(let i=0; i<h2TopList.length; i++){
                  if(scrollPosition >= h2TopList[i] && scrollPosition <= h2TopList[i+1]){
                    $categoryLinkList.eq(i).addClass('active').siblings().removeClass('active');
                    var top = $categoryLinkList.eq(i).offset().top - $categoryLinkList.eq(0).offset().top;
                    $categorySlider.css({
                      top: top,
                      bottom: listHeight - top - $categoryLinkList.eq(i).innerHeight()
                    })
                  }
                }
              }, 200);
            }
          }
        })
      })
    }else{
      var $articleBodyDom = $articleDom.find('#article-main-body');
      $articleBodyDom.find('p').eq(0).after(`
        <nav class="article-main-category-mb">
          <h3 class="article-category-title">Category</h3>
          <div class="article-category-list"></div>
        </nav>
      `);
      var $categoryDom = $articleDom.find('.article-main-category-mb .article-category-list');
      var $articleH2List = $articleBodyDom.find('h2');
      var html = '';
      $articleH2List.each(function(index, el){
        var $this = $(this);
        var text = $this.text();
        var id = text.toLowerCase().replace(/\s/g, '-');
        $this.attr('id', id);
        html += `<a class="article-category-item" href="#${id}">${text}</a>`;
      })
      $categoryDom.html(html);
      var $categoryLinkList = $categoryDom.find('.article-category-item');
      $(window).on('load', function(){
        var topHeight = $('#StickyHeaderWrap').innerHeight();
        $categoryLinkList.click(function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          var id = CSS.escape(href.replace('#', ''));
          var $targetDom = $(`#${id}`);
          if($targetDom.length > 0){
            window.scrollTo({
              top: $targetDom.offset().top - topHeight - 30,
              behavior: 'smooth'
            })
          }
        })
      })
    }
  })
  
  /* The Last */
  document.addEventListener('page:loaded', function() {
    $(window).on('load', function(){
      ScrollTrigger.refresh();
    })
    // $(window).on('resize', function(){
    //   ScrollTrigger.refresh();
    // })
  })
})()